import(/* webpackMode: "eager" */ "/home/r11/choice-graphics/src/app/global-error.tsx");
